import { FactorLensDataSet } from "@/services/report-dashboard/raDashboard.data.service"
import { RADashboardCardPrefs } from "./raDashboard.interface"

export enum FactorLensDataType {
  Portfolio = "Portfolio",
  Benchmark = "Benchmark",
  Active = "Active"
}
const DATA_TYPE_OPTIONS = [FactorLensDataType.Portfolio, FactorLensDataType.Benchmark, FactorLensDataType.Active]
export const isFactorLensDataType = (value: any): value is FactorLensDataType => {
  return DATA_TYPE_OPTIONS.includes(value);
}


export interface FactorLensState {
  selectedDataType: string | null;
  selectedFactorBox: FactorLensFocus | null;
  contributionsShown: boolean;
  waterfallShown: boolean;
};

export interface FactorLensFocus {
  level: number;
  name: string;
}

export interface FactorRiskColors {
  totalColor: string;
  totalBorder: string;
  totalSelected: string;
  specificColor: string;
  specificBorder: string;
  specificSelected: string;
  barColors: string[];
  negativeBarColor: string;
}

export interface FactorBoxData {
  width: number;
  aspect: number;
  selected: boolean;
  setAsSelected: () => void;
  factorName: string;
  factorContrib: number;
  factorWeight: number;
  colors: FactorRiskColors;
  barColorIndex?: number;
}

export interface SecurityContributionsData {
  shown: boolean;
  toggleVisibility: () => void;
  cardPrefs?: RADashboardCardPrefs;
  onCardPrefsChange?: (newPrefs: RADashboardCardPrefs) => void;
}

export interface WaterfallData {
  shown: boolean;
  toggleVisibility: () => void;
  factorData?: FactorLensDataSet | null;
  colors: FactorRiskColors;
}

export interface FactorGridProps {
  gridData: FactorLensDataSet;
  cardState: FactorLensState;
  setSelected: (focus: FactorLensFocus) => void;
  colors: FactorRiskColors;
};

export interface GridLayout{
  layout: GridItem[];
}

export interface GridItem{
  w: number;
  h: number;
};